/*
  People in the store's search box.
  Asks the community app for members who chose "Let people find me from the shop's search" and adds a "People"
  group under Dawn's own results. Only a name and a link come back; the link opens the profile in the community
  app, which asks visitors to sign in. Fewer than three letters shows nothing. If the community can't be reached
  the box simply shows the usual product results.
*/
(function () {
  var script = document.currentScript;
  var api = script && script.getAttribute('data-api');
  if (!api) return;

  function setup(el) {
    var input = el.querySelector('input[type="search"]');
    var results = el.querySelector('[data-predictive-search]');
    if (!input || !results || el.__ssPeople) return;
    el.__ssPeople = true;

    var people = [];
    var timer = null;
    var painting = false;

    function paint() {
      painting = true;
      var old = results.querySelector('.ss-people');
      if (old) old.remove();
      if (people.length && input.value.trim().length >= 3) {
        var box = document.createElement('div');
        box.className = 'ss-people';
        var h = document.createElement('h3');
        h.className = 'ss-people__title';
        h.textContent = 'People';
        var ul = document.createElement('ul');
        ul.className = 'ss-people__list';
        people.forEach(function (p) {
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.href = p.url;
          a.className = 'link link--text';
          a.textContent = p.name;
          li.appendChild(a);
          ul.appendChild(li);
        });
        box.appendChild(h);
        box.appendChild(ul);
        results.appendChild(box);
      }
      painting = false;
    }

    new MutationObserver(function () {
      if (!painting) paint();
    }).observe(results, { childList: true });

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 3) {
        people = [];
        paint();
        return;
      }
      timer = setTimeout(function () {
        fetch(api + '?q=' + encodeURIComponent(q))
          .then(function (r) { return r.ok ? r.json() : { people: [] }; })
          .then(function (d) {
            if (input.value.trim() !== q) return;
            people = (d && d.people) || [];
            paint();
          })
          .catch(function () { people = []; paint(); });
      }, 300);
    });
  }

  document.querySelectorAll('predictive-search').forEach(setup);
})();
